import { schema } from 'normalizr'

const AddressSchema = new schema.Entity('addresses')

export default AddressSchema
